import { getBackendUrl } from "@Utils";
import axiosWrapper from "../services/axiosWrapper";
import { SOMETHING_WENT_WRONG, TOAST_TYPE_ERROR, TOAST_TYPE_SUCCESS } from "../services/constants";
import { showToastNotification } from "./toast";
import _ from "lodash";
import {
  setRefreshFileManager,
  setSelectedFiles,
  setCurrentFolder,
  emptyCurrentFolder,
  setFileManagerBreadCrumbData,
} from "../reducers/refreshFileManager";
import {
  setFileVersionData,
  mergeFileVersionData,
  setFilesDataAction,
  resetFilesData as resetFilesDataAction,
  setFileDependenciesAction,
  setResourcesUnderWhichFilesSharedAction,
  setFileVersionIdAction,
} from "../reducers/fileVersion";
import {
  setIsFileVersionUploading,
  setCurrentFileUploadProperties,
  setFileUploadProperties,
  minimiseFileUpload,
  maximiseFileUpload,
  closeFileUpload,
  setFileUploadData,
  removeFileUploadData,
  removeAllFileUploadData,
  updateFileUploadData,
  emptyFileUploadData,
  locationRemove,
  documentRemove,
  locationChange,
  documentChange,
} from "../reducers/minimiseFileUpload";
export { setCurrentPath } from "../reducers/filesStatuses";

export function setFileVersions(data, fileId) {
  return setFileVersionData({ data, fileId });
}

export {
  setIsFileVersionUploading,
  setCurrentFileUploadProperties,
  setFileUploadProperties,
  minimiseFileUpload,
  maximiseFileUpload,
  closeFileUpload,
};

export function setFilesData(data) {
  return setFilesDataAction(data);
}

export function resetFilesData() {
  return resetFilesDataAction();
}

export {
  setFileUploadData,
  removeFileUploadData,
  removeAllFileUploadData,
  updateFileUploadData,
  emptyFileUploadData,
  locationRemove,
  documentRemove as documentTypeRemove,
  locationChange,
  documentChange as documentTypeChange,
};

export function setFileDependencies(data) {
  return setFileDependenciesAction(data);
}

export function setResourcesUnderWhichFilesShared(data, fileId) {
  return setResourcesUnderWhichFilesSharedAction({ data, fileId });
}

export function mergeFileVersions(data) {
  return mergeFileVersionData(data);
}

export function refreshFileManager(data) {
  return setRefreshFileManager(data);
}
export function selectedFilesFileManager(data) {
  return setSelectedFiles(data);
}

export function setCurrentFolderInFileManager(data) {
  return setCurrentFolder(data);
}

export function emptyCurrentFolderInFileManager() {
  return emptyCurrentFolder();
}

export function fileManagerBreadCrumb(data) {
  return setFileManagerBreadCrumbData(data);
}

export function getFileVersions(data) {
  return (dispatch) => {
    axiosWrapper
      .post(`${getBackendUrl()}/fileOperations/getFileVersions`, data)
      .then((response) => {
        if (response.data.status) {
          dispatch(setFileVersions(response.data.data, data.fileId));
        }
      })
      .catch(() => function () {});
  };
}

export function getFileDependencies(data) {
  return (dispatch) => {
    axiosWrapper
      .post(`${getBackendUrl()}/fileOperations/getFileDependencies`, data)
      .then((response) => {
        if (response.data.status) {
          dispatch(
            setFileDependencies({
              fileVersionId: data.fileVersionId,
              data: response.data.data,
            }),
          );
        }
      })
      .catch(() => function () {});
  };
}

export function saveFileDependencies(data) {
  return async () => {
    await axiosWrapper.post(`${getBackendUrl()}/fileOperations/saveFileDependencies`, data);
  };
}

export function removeFileDependency(data) {
  return async () => {
    await axiosWrapper.post(`${getBackendUrl()}/fileOperations/removeFileDependency`, data);
  };
}

export function getFileVersionData(data) {
  return (dispatch) => {
    axiosWrapper
      .post(`${getBackendUrl()}/fileOperations/getFileVersionData`, data)
      .then((response) => {
        if (response.data.status) {
          dispatch(
            setFilesData({
              [data.fileVersionId]: response.data.data,
            }),
          );
        } else {
          dispatch(
            showToastNotification({
              content: response.data.message,
              type: TOAST_TYPE_ERROR,
            }),
          );
        }
      })
      .catch(() => function () {});
  };
}

export function getResourcesUnderWhichFilesShared(data, returnValue = false) {
  return async (dispatch) => {
    const response = await axiosWrapper.post(
      `${getBackendUrl()}/fileOperations/getResourcesUnderWhichFilesShared`,
      data,
    );
    if (response.data && !returnValue) {
      dispatch(setResourcesUnderWhichFilesShared(response.data, data.fileId));
    }
    if (returnValue) {
      return response.data;
    }
  };
}

export function createFileVersion(data) {
  return (dispatch) => {
    axiosWrapper
      .post(`${getBackendUrl()}/fileOperations/createFileVersion`, data)
      .then((response) => {
        if (response.data.status) {
          // dispatch(mergeFileVersions(response.data.data));
          dispatch(refreshFileManager(true));
        }
      })
      .catch(() => function () {});
  };
}

export function saveNoteInFileVersion(data) {
  return () => {
    axiosWrapper.post(`${getBackendUrl()}/fileOperations/saveNoteInFileVersion`, data);
  };
}

export function saveFileVersionStatusHistory(data) {
  return (dispatch) => {
    let toastType = TOAST_TYPE_ERROR;
    let message = "";
    axiosWrapper
      .post(`${getBackendUrl()}/signHistory/storeSignHistory`, data)
      .then((response) => {
        if (response.data.status) {
          toastType = TOAST_TYPE_SUCCESS;
        }
        message = response.data.message;
      })
      .catch(
        () =>
          function () {
            message = SOMETHING_WENT_WRONG;
          },
      )
      .finally(() => {
        dispatch(
          showToastNotification({
            content: message,
            type: toastType,
          }),
        );
      });
  };
}

export const createMergeFile = async (data) => {
  const response = await axiosWrapper.post(`${getBackendUrl()}/fileUpload/createMergeFile`, data);
  return response;
};
export const createFileShortcut = async (data) => {
  const response = await axiosWrapper.post(`${getBackendUrl()}/fileOperations/createFileShortcut`, data);
  return response;
};
export const consumeExternalFiles = async (data) => {
  const response = await axiosWrapper.post(`${getBackendUrl()}/fileOperations/consumeExternalFiles`, data);
  return response;
};
export const getFilesData = async (data) => {
  const response = await axiosWrapper.post(`${getBackendUrl()}/fileOperations/getFileManagerProps`, data);
  return response;
};

export const createMergeEstimate = async (data) => {
  const response = await axiosWrapper.post(`${getBackendUrl()}/estimate/createMergeEstimate`, data);
  return response;
};

export const createContainer = async (data) =>
  await axiosWrapper.post(`${getBackendUrl()}/fileUpload/createNewContainer`, data);

export const saveEngineType = async (data) =>
  await axiosWrapper.post(`${getBackendUrl()}/fileUpload/saveEngineType`, data);

export const createFolder = async (data) => await axiosWrapper.post(`${getBackendUrl()}/fileSystemServer/`, data);

export function saveCustomFieldsData(data) {
  return axiosWrapper.post(`${getBackendUrl()}/fileOperations/saveCustomFieldsData`, data);
}

export function saveCustomMetadata(data) {
  return axiosWrapper.post(`${getBackendUrl()}/fileOperations/saveCustomMetadata`, data);
}

export function getFormTemplate(data) {
  return axiosWrapper.post(`${getBackendUrl()}/projects/getFormTemplate`, data);
}

export function getFormTemplateId(data) {
  return axiosWrapper.post(`${getBackendUrl()}/projects/getFormTemplateId`, data);
}

export function setCurrentFileVersionId(data) {
  return setFileVersionIdAction(data);
}
export const importExcelContainers = async (data) =>
  await axiosWrapper.post(`${getBackendUrl()}/fileUpload/importExcelContainers`, data);

const checkForDuplicateFile = (fileToSearch, currentFiles) => {
  // Naming conventions: append: ${filname}(unique_number)
  const hash = new Map();
  let updatedCount = 0;
  const currentFileExt = fileToSearch.split(".").pop().toLowerCase();
  const currentFileName = fileToSearch.split(".").slice(0, -1).join(".").trim();

  let allFiles = currentFiles; // fileObj.detailsviewModule.gridObj.currentViewData;
  allFiles = allFiles.filter((file) => file.name.split(".").pop().toLowerCase() == currentFileExt);

  // take only the name part and ignore the extension
  allFiles = allFiles.map((file) => file.name.split(".").slice(0, -1).join("."));

  allFiles.forEach((name) => {
    // replace last occured numbering(  ex. (3)  ) so that acutal file can be fetched
    const versionsOfName = name.replace(/\([0-9]+\)$/, "").trim();

    if (name.trim() == currentFileName || versionsOfName == currentFileName) {
      if (!hash.has(currentFileName)) {
        hash.set(currentFileName, 1);
      } else {
        const count = hash.get(currentFileName);
        hash.set(currentFileName, count + 1);
      }
    }
  });
  if (hash.get(currentFileName)) {
    updatedCount = hash.get(currentFileName);
  }
  if (updatedCount == 0) {
    return {
      found: false,
    };
  }
  return {
    found: true,
    newSuggestedName: `${currentFileName}(${updatedCount}).${currentFileExt}`,
  };
};

const matchNomenclature = (file, fileNomenclatureRule) => {
  let fileName = file.name.split(".");
  fileName.pop();
  fileName = fileName.join(".").split(fileNomenclatureRule.separator);
  const isFileNomenclatureCorrect = fileNomenclatureRule.fields?.every((rule, index) => {
    let output = false;

    if ((rule.type == "text" || rule.type == "number") && !rule.allowedCharacters) {
      return true;
    }

    const textCondition = rule.type == "text" && fileName[index]?.length == rule.allowedCharacters;
    const numberCondition = rule.type == "number" && fileName[index]?.length == rule.allowedCharacters;
    const selectCondition = rule.type == "single select" && rule.options?.includes(fileName[index]);

    if (textCondition || numberCondition || selectCondition) {
      output = true;
    }
    return output;
  });
  return isFileNomenclatureCorrect;
};

export const processFileList = ({
  fileList,
  currentFiles,
  fileNomenclature,
  isFileVersionUploading,
  uploadFolderData,
  uploadSpaceId,
  selectedSpaceTypeInFileManager,
  currentFolder,
}) =>
  fileList.map((file) => {
    const { name, size, isFolder = false, resourcesList, error } = file;
    let duplicateFileStatus = { found: false };
    const isMetadataPending = true;
    let isFileNomenclatureCorrect = true; // false
    /*
      start
    */
    const fileNomenclatureRule = fileNomenclature || {};

    if (!Object.keys(fileNomenclatureRule).length) {
      isFileNomenclatureCorrect = true;
    } else if (!isFolder) {
      isFileNomenclatureCorrect = matchNomenclature(file, fileNomenclatureRule);
    } else {
      for (let i = 0; i < resourcesList.length; i++) {
        isFileNomenclatureCorrect = matchNomenclature(resourcesList[i], fileNomenclatureRule);
        if (!isFileNomenclatureCorrect) {
          break;
        }
      }
    }

    if (isFileVersionUploading !== true) {
      duplicateFileStatus = checkForDuplicateFile(name, currentFiles);
    }
    const isDuplicate = duplicateFileStatus.found;
    return {
      name,
      size,
      duplicateFileStatus,
      isDuplicate,
      progress: 0,
      bytesUploaded: 0,
      progressCompleted: false,
      error: error ?? false,
      status: "Processing...",
      isMetadataPending,
      triggerFileUpload: false,
      file,
      isFileNomenclatureCorrect,
      isFolder,
      hierarchyId: _.get(uploadFolderData, "id", _.get(currentFolder, "hierarchyId")),
      spaceId: uploadSpaceId,
      spaceType: selectedSpaceTypeInFileManager,
    };
  });
